import React from 'react'
import { CChartLine } from '@coreui/react-chartjs'

// Orders-per-day line chart. analyticsData: [{ name: 'YYYY-MM-DD', count, price }]
export default function Visitors({ analyticsData = [], style }) {
    const labels = analyticsData.map(d => d.name)
    return (
        <div style={style}>
            <CChartLine
                data={{
                    labels,
                    datasets: [
                        {
                            label: 'Orders',
                            data: analyticsData.map(d => d.count),
                            borderColor: '#4facfe',
                            backgroundColor: 'rgba(79, 172, 254, 0.15)',
                            pointBackgroundColor: '#4facfe',
                            fill: true,
                            tension: 0.4,
                        },
                        {
                            label: 'Revenue',
                            data: analyticsData.map(d => d.price ?? 0),
                            borderColor: '#00f2fe',
                            backgroundColor: 'rgba(0, 242, 254, 0.08)',
                            pointBackgroundColor: '#00f2fe',
                            fill: true,
                            tension: 0.4,
                        },
                    ],
                }}
                options={{
                    maintainAspectRatio: false,
                    plugins: { legend: { display: true } },
                    scales: { y: { beginAtZero: true } },
                }}
            />
        </div>
    )
}
